import { css } from 'goober';
import React, { StrictMode, useEffect, useState, } from 'react';
import App from './app';
import FeedLoading from './components/FeedLoading';
import { ProviderComponent } from './components/Provider';
import constants from './constants';
import State from './state';
import colors from './styles/colors';
import { transparentize } from './styles/mixins';
import { checkCoachMarkShown } from './utils/common';
import { initialiseGondolinBridge } from './utils/data';
const Background = css `
  background: ${colors.black};
  height: 100%;
  color: ${colors.white};
  transform-style: preserve-3d;
  touch-action: none;
  position: relative;
`;
const Gradient = css `
  position: absolute;
  width: 100%;
  left: 0;
  height: 30%;
  pointer-events: none;
  transform: translateZ(3px);
  background-image: linear-gradient(
    to bottom,
    ${transparentize(0.65, colors.black)},
    ${transparentize(1, colors.black)}
  );
`;
const TopGradient = css `
  top: 0;
`;
const BottomGradient = css `
  background-image: linear-gradient(
    to top,
    ${transparentize(0.62, colors.black)},
    ${transparentize(1, colors.black)}
  );
  bottom: 0;
`;
const Root = ({ isSDK, glances, onClickShare, onClickLike, onClickCTA, onChangeGlanceIndex, setStoryIdInPWA, setPauseAutoPlay, disableShare = false, openApp, fromSportsPage = false, jioBannerButtonText = 'Get App', }) => {
    const [isMounted, setIsMounted] = useState(false);
    State.isSdk = isSDK;
    State.onClickShare = onClickShare;
    State.onClickLike = onClickLike;
    State.onClickCTA = onClickCTA;
    State.disableShare = disableShare;
    State.openApp = openApp;
    State.fromSportsPage = fromSportsPage;
    State.jioBannerButtonText = jioBannerButtonText;
    useEffect(() => {
        initialiseGondolinBridge();
        setIsMounted(true);
        State.hasCoachMark = State.fromSportsPage ? false : !checkCoachMarkShown();
    }, []);
    /**
     * As for improving Lightscore for glance-web-ssr:
     * 1. Instead of returning null which results in empty screen, we are returning FeedLoading component.
     * 2. We have tweaked the FeedLoading Component to accept inline style instead of goober css stylesheet.
     * 3. As for getting goober css stylesheet, we have to do additional setup in glance-web-ssr.
     */
    if (!isMounted) {
        // Consuming through Glance-web-ssr.
        if (!isSDK) {
            return React.createElement(FeedLoading, null);
        }
        // Consuming through SDK.
        return null;
    }
    return (React.createElement(ProviderComponent, null,
        React.createElement("main", { className: Background, id: constants.MAIN_BACKGROUND_ID },
            React.createElement(StrictMode, null,
                React.createElement(App, { isSDK: isSDK, glances: glances, onChangeGlanceIndex: onChangeGlanceIndex, isAutoPlayPaused: setPauseAutoPlay, setStoryIdInPWA: setStoryIdInPWA })),
            React.createElement("div", { className: `${Gradient} ${TopGradient}` }),
            React.createElement("div", { className: `${Gradient} ${BottomGradient}` }))));
};
export default Root;
//# sourceMappingURL=glancefeed.js.map